import {TimePeriod} from '../../lib/iprs-react-library/src/index.js';

const handleDrop = (info, api, setCalendarEvent, rotaMode, calendarApi) => {
        
        const {
            event: {
                extendedProps: {
                    apiEvent: {
                        BookingID:  bookingId           = 0,
                        PartyID:    oldPartyID          = 0,
                        RotaTypeID: rotaTypeID          = 0,
                        RotaID:     rotaID              = 0,
                        AppointmentTypes: appTypes      = [],
                        Description: desc               = '',
                        Title: title                    = '',
                        Available
                    }
                },
                start, end
            },
            oldEvent: {
                end: oldEnd, start: oldStart
            },
            view: {
                calendar:           calRef
            },
            newResource:            newResourceOb
        }  = info
        
        if( bookingId ) {
            rerender( calendarApi );
            calendarApi.unselect()
            return;
        }
        
        const oldTimes = new TimePeriod( oldStart, oldEnd );
        const newTimes = new TimePeriod( start, end );
        
        const partyID = newResourceOb?  newResourceOb.id: oldPartyID
        
        /* Depending whether we are moving between  */
        let createSave;
        if ( rotaMode ){
            if( !newTimes.overlaps(oldTimes) || (partyID !== oldPartyID) ){
                //const appTypeIds = appTypes.map( t => t.AppointmentTypeID );
                createSave = api.createRota(partyID,    start, 
                                                        end, 
                                                        null,
                                                        rotaTypeID);
                if(rotaMode){
                    createSave = createSave.then( r => api.saveRotaAppointmentType( r.apiResult.RotaID, appTypes ) );
                }
            }else{
                createSave = api.updateRota(rotaID,     start, 
                                                    end, 
                                                    null,
                                                    partyID,
                                                    rotaTypeID);   
            }
        }else{
            if( partyID !== oldPartyID ){
                createSave = api.createTask(partyID,    start, 
                                                    end, 
                                                    desc,
                                                    rotaTypeID,
                                                    Available,
                                                    title); 
            }else{
                
                createSave = api.updateTask(rotaID,     start, 
                                                    end,
                                                    desc,
                                                    partyID,
                                                    rotaTypeID,
                                                    Available,
                                                    title);
            }
        }
        
        createSave.then( response => {

            rerender( calendarApi );
            calRef.unselect(); // clear date selection

            setCalendarEvent(null);
        })
        .catch(e => {
            
            calRef.unselect(); // clear date selection
            
            rerender( calendarApi );
        })
    }

/* tell the calendar to reload */
const rerender = calendarApi => {

    if( calendarApi.current.render ){
            calendarApi.current.render()
    }
    if( calendarApi.current.getApi() ){
        const capi = calendarApi.current.getApi()
        capi.refetchEvents();
    }
}

export default              handleDrop;
